import { useState } from 'react';
import styled from 'styled-components';


const TooltipContainer = styled.div`
  position: relative;
  display: inline-block;
  width: 100%;
  height: 100%;
  z-index: 100;
`;

const TooltipText = styled.p`
  margin: 0;
  font-size: 12px;
  color: ${({ theme }) => theme.colors.main.white};
  line-height: 1.5;
  word-break: break-word;
`;

const TooltipContent = styled.div`
  visibility: ${props => (props.show ? 'visible' : 'hidden')};
  opacity: ${props => (props.show ? '1' : '0')};
  background-color: #353a46;
  color: white;
  text-align: center;
  border-radius: 6px;
  padding: 8px 12px;
  position: absolute;
  z-index: 1050;
  ${props => (props.top !== undefined ? `top: ${props.top};` : '')}
  ${props => (props.bottom !== undefined ? `bottom: ${props.bottom};` : '')}
  ${props => (props.left !== undefined ? `left: ${props.left};` : '')}
  ${props => (props.right !== undefined ? `right: ${props.right};` : '')}
  ${props => (props.transform ? `transform: ${props.transform};` : '')}
  width: max-content;
  max-width: 200px;
  transition: opacity 0.3s ease;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);

  &::after {
    content: '';
    position: absolute;
    top: 100%;
    left: 50%;
    margin-left: -5px;
    border-width: 5px;
    border-style: solid;
    border-color: #353a46 transparent transparent transparent;
  }

  @media (max-width: 600px) {
    max-width: 150px;
    font-size: 11px;
  }
`;

const ButtonHelpTooltip = ({ 
  enabled = false, 
  text = '', 
  children, 
  onMouseEnter, 
  onMouseLeave,
  top,
  bottom = '125%',
  left = '50%',
  right,
  transform = 'translateX(-50%)'
}) => {
  const [showTooltip, setShowTooltip] = useState(false);

  if (!enabled || !text) {
    return children;
  }

  const handleMouseEnter = () => {
    setShowTooltip(true);
    onMouseEnter?.();
  };

  const handleMouseLeave = () => {
    setShowTooltip(false);
    onMouseLeave?.();
  };

  return (
    <TooltipContainer onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
      <TooltipContent 
        show={showTooltip}
        top={top}
        bottom={bottom}
        left={left}
        right={right}
        transform={transform}
      >
        <TooltipText>{text}</TooltipText>
      </TooltipContent>
      {children}
    </TooltipContainer>
  );
};

export default ButtonHelpTooltip;